module.exports = __webpack_public_path__ + "img/LynnBishop@2x.1de9d044.png";